import {
  List,
  ListItem,
  ListItemText,
  Chip,
  Typography,
  Divider,
  Box,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
  import { Service } from "../../../types";
  import { useNavigate } from "react-router-dom";
  
  const MyServicesTable: React.FC<{ services: Service[]; admin: boolean }> = ({ services, admin }) => {
    const navigate = useNavigate();
  
  return (
    <Box sx={{ width: '100%', maxWidth: 560, mx: 'auto' }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ bgcolor: "grey.100", px: 2, py: 1, borderRadius: 0.5 }}>
        <Typography variant="h6" fontWeight={700}>
          Your Services
        </Typography>
        {admin && (
          <IconButton size="small" onClick={() => navigate("/admin/manage-services")} aria-label="Edit services">
            <Edit fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Divider sx={{ my: 1 }} />
      <Card
        elevation={2}
        sx={{
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ '&:last-child': { pb: 3 } }}>
          {services.length ? (
            <List dense>
              {services.map((s) => (
                <ListItem
                  key={s.id}
                  disableGutters
                  secondaryAction={
                    <Chip size="small" label={`${s.time} min • $${s.price}`} />
                  }
                >
                  <ListItemText
                    primary={s.title}
                    primaryTypographyProps={{ fontWeight: 600, fontSize: '1rem' }}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No services assigned
            </Typography>
          )}
          {!admin && (
            <Typography variant="caption" color="error" sx={{ display: "block", mt: 1 }}>
              Contact an admin to change services
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
  };
  
  export default MyServicesTable;
  
